import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimoniosDestacados } from '../data/testimonios';
import { Emoji } from './Emoji';
const stats = [{
  value: '6',
  label: 'Tomos listos',
  emoji: '📦'
}, {
  value: '6',
  label: 'Bonos incluidos',
  emoji: '🎁'
}, {
  value: '+900',
  label: 'personas confían',
  emoji: '👥'
}, {
  value: '4.9/5',
  label: 'calificación',
  emoji: '⭐'
}];
export function TestimonialStrip() {
  return <section aria-label="Prueba social" className="w-full bg-canvas py-10 sm:py-14" data-id="element-234" data-mp="19u6iuwq8rnx0">
      <div className="mx-auto w-full max-w-content px-4 sm:px-6" data-id="element-235" data-mp="1ergeiu484vta">
        <dl className="mx-auto grid max-w-md grid-cols-2 items-start gap-x-6 gap-y-7 text-center lg:max-w-3xl lg:grid-cols-4" data-id="element-236" data-mp="111cxqio45ub8">
          {stats.map(stat => <div key={stat.label} className="min-w-0" data-id="element-237" data-mp="14zsiefwq2qlh">
              <dt className="sr-only" data-id="element-238" data-mp="1sqxwapj3r8t5">{stat.label}</dt>
              <dd data-id="element-239" data-mp="1xifzzlcifnht">
                <span className="block whitespace-nowrap font-display text-[clamp(1.5rem,7vw,3rem)] font-black leading-none tracking-tight text-ink-900" data-id="element-240" data-mp="1xizcgmje5jog">
                  {stat.value}
                </span>
                <span className="mt-2 inline-flex items-center justify-center gap-1.5 text-[11px] font-semibold leading-tight text-celeste-700 sm:text-sm" data-id="element-241" data-mp="1lim32izsodjf">
                  <Emoji symbol={stat.emoji} data-id="element-242" data-mp="208jvxc8o5rey" />
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-10 grid gap-4 sm:gap-5 lg:grid-cols-3" data-id="element-243" data-mp="2963ugdf5d9lv">
          {testimoniosDestacados.map(item => <li key={item.initials + item.name} className="h-full" data-id="element-244" data-mp="255k2do9fkw6l">
              <figure className="flex h-full flex-col rounded-2xl border border-line bg-white p-4 shadow-card sm:p-5" data-id="element-245" data-mp="2j4jpgrhap30n">
                <div className="flex items-start gap-3 sm:gap-4" data-id="element-246" data-mp="2e71cmq05q3nd">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-celeste-200 font-display text-xs font-bold text-celeste-800 sm:h-11 sm:w-11" aria-hidden="true" data-id="element-247" data-mp="oqs815sq5eun">
                    {item.initials}
                  </span>
                  <div className="min-w-0" data-id="element-248" data-mp="2oumckj1z50bg">
                    <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-249" data-mp="2svel1a30v16o">
                      {Array.from({
                    length: 5
                  }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-250" data-mp="2xvaq7cnggynt" data-mpi={index} />)}
                    </span>
                    <blockquote className="mt-2 font-display text-[14px] font-bold leading-snug text-ink-900 sm:text-[15px]" data-id="element-251" data-mp="3civuh9w2h3xb">
                      “{item.quote}”
                    </blockquote>
                  </div>
                </div>
                <figcaption className="mt-auto pt-3 text-[13px] text-ink-400 sm:pl-[56px] sm:text-sm" data-id="element-252" data-mp="3lln89gcf0bs4">
                  — {item.name}, {item.location}
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}